import { MenuItem } from "@/core/models";
import { BasePriceCalculationStrategy, RegularModifierPriceStrategy } from ".";

export class RegularPriceStrategy extends BasePriceCalculationStrategy {

  constructor() {
    super(new RegularModifierPriceStrategy());
  }

  protected extractFactorPrice(menuItem: MenuItem): bigint {
    return BigInt(menuItem?.precio ?? 0n);
  }
}